import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BreadcrumbLink = styled("a", ({ $theme, "aria-current": ariaCurrent }) => __spreadValues(__spreadProps(__spreadValues({}, $theme.typography.p4), {
  textDecoration: "none",
  color: $theme.colors["text-global-secondary"],
  ":hover": {
    textDecoration: "underline"
  },
  ":active": {
    textDecoration: "underline",
    color: $theme.colors["text-global-primary"]
  },
  ":focus-visible": __spreadProps(__spreadValues({}, $theme.focusOutline), {
    borderRadius: $theme.radii[4]
  })
}), ariaCurrent === "page" && {
  fontWeight: $theme.fontWeights.medium,
  color: $theme.colors["text-global-primary"],
  ":active": {
    textDecoration: "underline",
    color: $theme.colors["text-global-secondary"]
  }
}));

export { BreadcrumbLink };
